import type { PeriodPreset } from "@/hooks/usePeriodFilter";
import { loadAdminPreferences } from "@/lib/adminSettings";

const periodValues = new Set<PeriodPreset>([
  "today",
  "yesterday",
  "7d",
  "14d",
  "30d",
  "90d",
  "6m",
  "1y",
  "all",
  "custom",
]);

export interface PeriodSearch {
  period: PeriodPreset;
  from?: string;
  to?: string;
}

export function validatePeriodSearch(search: Record<string, unknown>): PeriodSearch {
  const defaultPeriod = loadAdminPreferences().defaultPeriod;
  const period = typeof search.period === "string" && periodValues.has(search.period as PeriodPreset)
    ? (search.period as PeriodPreset)
    : defaultPeriod;

  const result: PeriodSearch = { period };

  if (period === "custom") {
    if (typeof search.from === "string") result.from = search.from;
    if (typeof search.to === "string") result.to = search.to;
  }

  return result;
}
